module.exports = __webpack_public_path__ + "static/media/coreformoblie.15d62100.png";